<h3 mat-dialog-title class="lt">{{ 'TITLE.PAYMENT' | translate }}</h3>
<mat-dialog-content class="container">
    <div class="receipt-data">
        <table [dataSource]="reference" mat-table>
            <ng-container matColumnDef="no">
                <th class="header-cell" mat-header-cell *matHeaderCellDef align="center">{{ 'TABLE.NO' | translate }}</th>
                <td mat-cell *matCellDef="let i = index" align="center">{{ i + 1 }}</td>
            </ng-container>
            <ng-container matColumnDef="system">
                <th mat-header-cell *matHeaderCellDef class="header-cell">{{ 'TABLE.SYSTEM' | translate }}</th>
                <td mat-cell *matCellDef="let data">{{ 'SYSTEM.' + data.system | translate }}</td>
            </ng-container>
            <ng-container matColumnDef="day">
                <th mat-header-cell *matHeaderCellDef class="header-cell">{{ 'TABLE.DAY' | translate }}</th>
                <td mat-cell *matCellDef="let data">{{ data.day }}</td>
            </ng-container>
            <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef class="header-cell">{{ 'TABLE.QUANTITY' | translate }}</th>
                <td mat-cell *matCellDef="let data">{{ data.quantity }}</td>
            </ng-container>
            <ng-container matColumnDef="price_one">
                <th mat-header-cell *matHeaderCellDef class="header-cell">{{ 'TABLE.UNIT_PRICE' | translate }}</th>
                <td mat-cell *matCellDef="let data">{{ data.price_one | currency }}</td>
            </ng-container>
            <ng-container matColumnDef="total_price">
                <th mat-header-cell *matHeaderCellDef class="header-cell">{{ 'TABLE.TOTAL_PRICE' | translate }}</th>
                <td mat-cell *matCellDef="let data">{{ data.totalPrice | currency }}</td>
            </ng-container>
            <tr class="header-row" mat-header-row *matHeaderRowDef="TABLE_COL"></tr>
            <tr class="data-row" mat-row *matRowDef="let row; columns: TABLE_COL"></tr>
        </table>
        <!-- <table mat-table [dataSource]="reference.amounts">
            <ng-container matColumnDef="no">
                <th mat-header-cell *matHeaderCellDef class="header-cell"> {{ 'TABLE.NO' | translate }} </th>
                <td mat-cell *matCellDef="let i = index"> {{ i + 1 }} </td>
                <td mat-footer-cell *matFooterCellDef>{{ 'LABEL.TOTAL_PRICE' | translate }}</td>
            </ng-container>
            <ng-container matColumnDef="system">
                <th mat-header-cell *matHeaderCellDef class="header-cell"> {{ 'TABLE.SYSTEM' | translate }} </th>
                <td mat-cell *matCellDef="let amount"> 
                    <app-image [id]="amount.photo" [width]="50" [height]="50" [avatar]="true"></app-image>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="day">
                <th mat-header-cell *matHeaderCellDef class="header-cell"> {{ 'TABLE.DAY' | translate }} </th>
                <td mat-cell *matCellDef="let amount"> {{ 'GENDER.' + amount.sex | translate }} </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef class="header-cell"> {{ 'TABLE.TOTAL_TICKET' | translate }} </th>
                <td mat-cell *matCellDef="let amount"> {{ getGroupAgeByID(amount.group_age)['group' + (currentLang == 'km' ? '_kh' : '')] }} </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="price_one">
                <th mat-header-cell *matHeaderCellDef class="header-cell"> {{ 'TABLE.PRICE_ONE' | translate }} </th>
                <td mat-cell *matCellDef="let amount"> {{ getNationalityByID(amount.nationality).nationality }} </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="total_price">
                <th mat-header-cell *matHeaderCellDef class="header-cell"> {{ 'TABLE.TOTAL_PRICE' | translate }} </th>
                <td mat-cell *matCellDef="let amount"> ${{ totalPrice }} </td>
                <td mat-footer-cell *matFooterCellDef> ${{ reference.totalAmount }} </td>
            </ng-container>
            <tr class="header-row" mat-header-row *matHeaderRowDef="TABLE_COL"></tr>
            <tr class="data-row" mat-row *matRowDef="let row; columns: TABLE_COL"></tr>
            <tr mat-footer-row *matFooterRowDef="TABLE_COL" class="footer-row"></tr>
        </table> -->
    </div>
    <!-- <div class="payment-method">
        <h3 class="lt">{{'LABEL.PAYMENT_METHOD' | translate}}</h3>
        <div class="option">
            <div class="label">
                <span class="text">ABA</span>
                <span class="border"></span>
            </div>
            <div class="pay-opt">
                <button mat-stroked-button mat-dialog-close="abapay"><img class="opt-img" src="/assets/img/aba_pay.webp"></button>
                <button mat-stroked-button mat-dialog-close="cards"><img class="opt-img" src="/assets/img/credit_debit.webp"></button>
            </div>
        </div>
    </div> -->
</mat-dialog-content>
<mat-dialog-actions align="end" style="position: relative;">
    <!-- <button mat-dialog-close mat-flat-button color="warn">{{'LABEL.CLOSE' | translate}}</button> -->
    <span class="noted-message">{{ 'LABEL.PAYMENT_NOTE' | translate }}</span>
    <div class="options">
        <div class="custom-group opt lt">
            <mat-checkbox id="agree" [formControl]="isAgree"></mat-checkbox>
            <label class="label" for="agree">{{ 'PUBLIC.I_AGREE' | translate }}<a class="accent" (click)="onAgree()">{{ 'PUBLIC.TERMS_AND_CON' | translate}}</a></label>
        </div>
        <button [disabled]="!isAgree.value" class="mat-custom-btn" mat-dialog-close="ABA" mat-flat-button color="accent">{{'LABEL.CHECK_OUT' | translate}}</button>
    </div>
</mat-dialog-actions>